import { getDispatch } from '../get-dispatch';
import { DispatchAction } from '../utility/dispatch-action';
import { OrderActions, ORDER_STATE_NAMESPACE } from './order.module-types';

export const dispatchOrderAction: DispatchAction<OrderActions> = getDispatch(
  ORDER_STATE_NAMESPACE
);
